import { isError } from "lodash";

export default function isShareCanceledError(value: unknown): value is Error {
  return isError(value) && value.message === "Share canceled";
}
